import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Text,
  HStack,
  Link,
  useColorMode,
} from "@chakra-ui/react";

export function Footer() {
  const { colorMode } = useColorMode();

  return (
    <Box
      as="footer"
      borderTopWidth="1px"
      borderColor={colorMode === "dark" ? "stone.700" : "stone.200"}
      bg={
        colorMode === "dark"
          ? "rgba(12, 10, 9, 0.5)"
          : "rgba(250, 250, 249, 0.5)"
      }
    >
      <Container maxW="6xl" py={4} px={4}>
        <HStack justify="space-between" align="center">
          {/* Left: Copyright */}
          <Text fontSize="sm" color="stone.500" minW="120px">
            © {new Date().getFullYear()} myrkup.com. All rights reserved.
          </Text>

          {/* Right: Doc links */}
          <HStack spacing={4} minW="120px" justify="flex-end">
            <Link
              as={RouterLink}
              to="/terms"
              fontSize="sm"
              color="stone.500"
              _hover={{ color: colorMode === "dark" ? "stone.300" : "stone.700" }}
            >
              Terms
            </Link>
            <Link
              as={RouterLink}
              to="/privacy"
              fontSize="sm"
              color="stone.500"
              _hover={{ color: colorMode === "dark" ? "stone.300" : "stone.700" }}
            >
              Privacy
            </Link>
            <Link
              as={RouterLink}
              to="/docs"
              fontSize="sm"
              color="stone.500"
              _hover={{ color: colorMode === "dark" ? "stone.300" : "stone.700" }}
            >
              Docs
            </Link>
          </HStack>
        </HStack>
      </Container>
    </Box>
  );
}
